<template>
    <h1 class="mb-8">Detalhes do Modelo de Avaliação</h1>
    <AssessmentModelForm
        :model-id="assessmentModelJobTitleId"
    />
</template>

<script setup>
import {
    computed,
} from "vue";
import {
    useRoute,
} from "vue-router";

import AssessmentModelForm from "@/components/assessments/models/AssessmentModelForm.vue";

const route = useRoute();
const assessmentModelJobTitleId = computed(() => String(route.params.id));
</script>
